<template>
  <div class="company">
    <a-row>
      <a-col :span="12" style="display: flex; align-items: center;">
        客户名称：{{ company.name || company.companyName }}
        <span style="margin-left: 10px" v-if="riskLabels.length > 0">
          <a-tag color="red" v-for="item in riskLabels" :key="item.id">
            {{ item.name }}
          </a-tag>
        </span>
      </a-col>
      <a-col :span="12">
        客户编码：{{ company.code || company.companyCode }}
      </a-col>
    </a-row>
    <a-tabs
      :activeKey="lastKey"
      :tabBarStyle="{ borderBottom: '0' }"
      class="tab"
      @change="handleChange"
    >
      <a-tab-pane key="trend" tab="信用趋势"></a-tab-pane>
      <a-tab-pane key="overview" tab="客户概览"></a-tab-pane>
      <a-tab-pane key="message" tab="客户信息"></a-tab-pane>
      <a-tab-pane key="mechanism" tab="机构报告"></a-tab-pane>
      <a-tab-pane key="credits" tab="信用额度"></a-tab-pane>
      <a-tab-pane key="guarantee" tab="担保"></a-tab-pane>
      <a-tab-pane key="Insurance" tab="保险"></a-tab-pane>
      <a-tab-pane key="application-data" tab="应收数据"></a-tab-pane>
      <a-tab-pane key="annex" tab="附件"></a-tab-pane>
      <a-tab-pane key="financial-report" tab="财务报告"></a-tab-pane>
      <a-tab-pane key="credit-rating" tab="信用评级"></a-tab-pane>
      <a-tab-pane key="client-center-score-card" tab="评分卡"></a-tab-pane>
      <a-tab-pane key="financial-analysis" tab="财务分析"></a-tab-pane>
      <a-tab-pane key="kpi-data" tab="KPI数据"></a-tab-pane>
      <a-tab-pane key="financing-data" tab="融资数据"></a-tab-pane>
      <a-tab-pane key="lengj-data" tab="棱镜数据"></a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { getCustomerOverview } from './api'

export default {
  computed: {
    ...mapGetters('app', ['company']),
  },
  data() {
    return {
      companyList: [],
      clientId: '',
      lastKey: this.$route.name || '',
      riskLabels: [],
    }
  },
  watch: {
    '$route.name': function(val) {
      this.lastKey = val
    },
  },
  mounted() {
    this.clientId = this.$route.params.id
    this._getCustomerOverview()
  },
  methods: {
    async _getCustomerOverview() {
      const { data } = await getCustomerOverview(this.clientId)
      this.riskLabels = data.account.riskLabels
      this.companyList = data.base
    },
    handleChange(key) {
      if (key === 'lengj-data' || key === 'mechanism') {
        let self = this
        this.$confirm({
          title: '提示?',
          content: '此接口收费，确定继续前往吗？',
          onOk() {
            self.lastKey = key
            self.$router.push({ name: key })
          },
          onCancel() {
            console.log('onCancel')
          },
        })
      } else {
        this.lastKey = key
        this.$router.push({ name: key })
      }
    },
  },
}
</script>

<style scoped lang="less">
.tab {
  position: relative;
  top: 15px;
}
.company /deep/ .ant-tabs-tab {
  padding: 8px;
  margin-right: 32px;
  font-size: 15px;
}
</style>
